export const LAST_FEATURE_KEY = "hiive_last_feature";
export const LAST_PROVIDER_KEY = "hiive_last_provider";

export const featureLabelMap: Readonly<Record<string, string>> = {
  "/hiives": "Hiives",
  "/chat": "Chats",
  "/feed": "Feed",
  "/discover": "Discover",
  "/profile": "Profile",
};
